<template>
  <div class="lv-img-preview-list">
    <WsImagePreviewButton001
      v-for="(img,imgIndex) in list"
      :key="imgIndex"
      small
      cancel
      :image="img"
      :percent="img.percent"
      :text-label="img.url"
      :isloading="img.isloading"
      :preview-url="img.previewUrl"
      class="lv-img-preview-list__item"
      @click="$emit('click', imgIndex)"
    />
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    }
  }
}
</script>